export class Permission {
  constructor(
    public general: boolean,
    public banks: boolean,
    public bankAccounts: boolean,
    public movements: boolean,
    public predictions: boolean,
    public users: boolean
  ) {}
}
